export default {
  orderStatus: {
    0: 'You have submitted the order, please wait for the purchasing agent to receive the order',
    23: 'The purchasing agent has received the order and is in contact with the merchant',
    22: 'Your goods have been ordered, transaction number: ',
    5: 'Merchant has shipped, shipping method: ',
    10: 'Your product has arrived at the Acbuy designated warehouse',
    16: 'Your return request has been submitted. Please wait while your agent processes it',
    17: 'Your replacement request has been submitted. Please wait while your agent processes it',
    buyerReturn:
      'The agent has submitted a return request due to customer needs, item risks, etc. Please wait for processing',
    buyerReplace:
      'The agent has submitted a replacement request due to customer needs, item risks, etc. Please wait for processing',
    20: 'The order has been returned',
    beenReturned: ' Check Refunds >',
    30: 'Your item has been shipped, view the parcel where it is located: ',
    43: 'Your return request is cancelled',
    44: 'Your exchange request is cancelled',
    49: 'Storage extension unpaid. Item considered voluntarily abandoned.',
  },
  expressNo: 'Tracking number: ',
}
